// การแปลง payload ของ run (ValidationProcess) เป็นสี ไอคอน และข้อความบน chip
// ใช้ร่วมกันระหว่าง views/ValidationProcess.vue (ตารางหลัก) และ components/ModelValidationRuns.vue
// (panel อ่านอย่างเดียวบนหน้า /GPTModelDetail) — ถ้าปล่อยให้ต่างคนต่างถือ logic ก้อนนี้
// run เดียวกันจะขึ้นสถานะคนละแบบในสองหน้า โดยเฉพาะเคส "ประมวลผลครบแต่ล้มเหลวทุกข้อ"
// ทุก method อ่านจาก item ที่รับเข้ามากับ $t เท่านั้น ไม่พึ่ง state ของ component ที่ใช้
export default {
  methods: {
    // สถานะที่ยังทำงานอยู่ — ใช้ที่เดียวกันทั้ง chip, tooltip, confirm dialog และ polling
    // เพื่อไม่ให้แต่ละจุดตีความ "ยังไม่จบ" ต่างกัน
    isRunning(status) {
      return ["Processing", "Reprocess", "Processing score"].includes(status);
    },
    // จำนวนแถวที่ล้มเหลวจริง มาจาก backend (นับจาก GenerateAnswers ไม่ใช่จาก counter ที่ denormalize ไว้)
    errorRowsOf(item) {
      const n = Number.parseInt(item?.errorRows, 10);
      return Number.isNaN(n) || n < 0 ? 0 : n;
    },
    // จำนวนคำถามทั้งหมดของ run อ่านจากตัวส่วนของ badge "N/M"
    totalRowsOf(item) {
      if (typeof item?.result !== "string") return 0;
      const total = Number.parseInt(item.result.split("/")[1], 10);
      return Number.isNaN(total) ? 0 : total;
    },
    // run ที่ "ประมวลผลครบ" ไม่ได้แปลว่า "สำเร็จ" — Status = success เขียนเมื่อทุกแถวถูกประมวลผล
    // ไม่ว่าผลจะเป็นคำตอบจริงหรือ error ดังนั้น run ที่พังทุกข้อจึงเคยขึ้น chip เขียวเหมือนสำเร็จเป๊ะ
    // ตรงนี้ใช้ errorRows ตัดสินสีแทน โดยไม่ต้องเปลี่ยนความหมายของ Status
    // (ถ้าเปลี่ยน Status จะทำให้ dropdown ของ Dashboard และปุ่ม Result ที่ gate ด้วย "success" พังตาม)
    hasFailedRows(item) {
      return this.errorRowsOf(item) > 0;
    },
    allRowsFailed(item) {
      const total = this.totalRowsOf(item);
      return total > 0 && this.errorRowsOf(item) >= total;
    },
    getQuestionTypeColor(type) {
      switch (type) {
        case "Positive":
          return "success";
        case "Negative":
          return "error";
        case "Chain":
          return "info";
        default:
          return "grey";
      }
    },
    // backend คืน code ("Positive"/"Negative"/"Chain") ไม่ใช่ข้อความที่แปลแล้ว การแปลจึงอยู่ตรงนี้
    getQuestionTypeText(type) {
      switch (type) {
        case "Positive":
          return this.$t("positive");
        case "Negative":
          return this.$t("negative");
        case "Chain":
          return this.$t("chain");
        default:
          return "-";
      }
    },
    getProcessStatusColor(item) {
      if (this.isRunning(item.status)) return "warning";
      // backend เขียนสถานะ error ได้หลายแบบ (error, error:score, error:gbtmodel-not-found,
      // error:gbtmodel-not-found(score)) การเทียบตรง ๆ ทำให้ค่าใหม่หลุดไปเป็นจุดเทาไร้ความหมาย
      if (typeof item.status === "string" && item.status.startsWith("error")) return "error";
      if (item.status === 'success') {
        if (this.allRowsFailed(item)) return "error";
        if (this.hasFailedRows(item)) return "warning";
        return "success";
      }
      return "grey";
    },

    getProcessStatusIcon(item) {
      if (this.isRunning(item.status)) return "mdi-clock-outline";
      if (typeof item.status === "string" && item.status.startsWith("error")) return "mdi-alert-circle-outline";
      if (item.status === 'success') {
        return this.hasFailedRows(item) ? "mdi-alert-circle-outline" : "mdi-check-circle-outline";
      }
      return "mdi-circle-outline";
    },

    // ข้อความบน chip: ยังเป็น "N/M" เหมือนเดิม แต่ต่อท้ายจำนวนที่ล้มเหลวเมื่อมี
    // คอลัมน์ Status ที่เป็นข้อความไม่ได้ถูกแสดง chip นี้จึงเป็นสัญญาณเดียวที่ผู้ใช้ได้รับ
    getProcessStatusText(item) {
      const failed = this.errorRowsOf(item);
      if (failed > 0 && !this.isRunning(item.status)) {
        return `${item.result} · ${this.$t("failedRows", { count: failed })}`;
      }
      return item.result;
    },
  },
};
